import { fragmentize } from "./fragmentize.js";
import { splitIntoSyllables } from "./splitIntoSyllables.js";
export function syllabize(unifiedWord, charType) {
  const fragments = fragmentize(unifiedWord);
  const syllables = [];
  fragments.forEach(fragment => {
    if (typeof fragment === 'string') {
      syllables.push(...splitIntoSyllables(fragment, charType));
    } else {
      syllables.push(...fragment);
    }
  });
  return syllables;
}